import React, { Component } from 'react';
import { Field, reduxForm, change, formValueSelector, FieldArray } from 'redux-form';
import submit from './submit';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

import Loader from '../../Common/Loader';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';
import CommonImageDisplay from '../CommonImageDisplay/CommonImageDisplay';

import messages from '../../../locale/messages';
import validate from './validate';
import { updateTempImages } from '../../../actions/siteadmin/TempImages/updateTempImages';
import { api, homepageUploadDir } from '../../../config';
import { formatLocale } from '../../../helpers/formatLocale';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';
import { demoRestriction } from '../../../actions/demoRestriction';
import { AddContentPlusIcon, DeleteContentPlusIcon } from '../../Common/Assets/SVGIcon/CommonSvgRemainingIcon';

import bt from '../../../components/commonStyle.css';
import s from './HomeSettingsForm.css';
export class HomeSettingsForm extends Component {

	constructor(props) {
		super(props)
		this.state = {
			selectedLanguages: []
		};
	}
	UNSAFE_componentWillReceiveProps(nextProps) {
		const { dynamicHomeBannerTitle } = nextProps;
		let filteredLanguages = dynamicHomeBannerTitle?.map((item) => { return item?.language })
		this.setState({ selectedLanguages: filteredLanguages });
	}

	successBanner = async (file, fromServer) => {
		const { change, updateTempImages, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('homeSectionImage1', fromServer && fromServer.fileName);
		await updateTempImages('Homepage', 'homeSectionImage1', fromServer && fromServer.fileName);
	}

	successImage = async (file, fromServer) => {
		const { change, updateTempImages, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('homeSectionImage2', fromServer && fromServer.fileName);
		await updateTempImages('Homepage', 'homeSectionImage2', fromServer && fromServer.fileName);
	}

	renderBannerTitle = ({ fields, meta: { touched, error } }) => {
		const { formatMessage } = this.props.intl;
		const { languageList, dynamicHomeBannerTitle } = this.props;
		const { selectedLanguages } = this.state;

		return (
			<div className={bt.languageBox}>
				{fields && fields.map((banner, index) => {
					let fieldLength = fields.length - 1;
					const currentLanguage = fields?.get(index)?.language;
					const availableLanguages = languageList.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);
					const languagesOption = [{ value: '', label: formatMessage(messages.chooseLanguageLabel) }];
					const languageOptionsFormatted = availableLanguages.map((locale) => {
						return {
							value: locale,
							label: formatLocale(locale)
						};
					});

					languagesOption.push(...languageOptionsFormatted || []);
					return (
						<div key={index}>
							<div className='twoColumnGrid'>
								<Field
									name={`${banner}.language`}
									component={SelectFieldComponent}
									label={formatMessage(messages.language)}
									options={languagesOption}
									inputClass={bt.formControlSelect}
								/>
								<Field
									name={`${banner}.value`}
									type="text"
									component={InputFieldComponent}
									inputClass={bt.formControlInput}
									placeholder={formatMessage(messages.homeTitle)}
									label={formatMessage(messages.homeTitle)} />

								<Field
									name={`${banner}.description`}
									component={InputFieldComponent}
									componentClass="textarea"
									label={formatMessage(messages.homeDescription)}
									placeholder={formatMessage(messages.homeDescription)}
									inputClass={cx(bt.textAreaHeight)} />
							</div>

							<div className={cx(bt.languageBtnContainer, 'svgImg', { [bt.languageBtnContainerOne]: (fieldLength > 0) })} >
								{(fields.length <= languageList?.length - 1) && fieldLength == index &&
									<Button className={cx(bt.languageBtn)} onClick={() => fields.length <= languageList?.length - 1 && fields.push({})}>
										<AddContentPlusIcon />
										<span>	{formatMessage(messages.addLanguage)}</span>
									</Button>
								}
								{fieldLength > 0 && <div>
									<Button className={cx(bt.languageBtn, bt.languageDeleteBtn)} onClick={() => fields.remove(index)}>
										<DeleteContentPlusIcon />
										<span>{formatMessage(messages.deleteLanguage)}</span>
									</Button>
								</div>}
							</div>
						</div>
					)
				})}
			</div >
		)
	}

	render() {
		const { handleSubmit, loading, submitting, homeSectionImage1, homeSectionImage2, dynamicHomeBannerTitle } = this.props;
		const { homeImageLoader, homeImageLoader2 } = this.props;
		const { formatMessage } = this.props.intl;

		return (
			<div >
				<h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.categoryBanner)}</h1>
				<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
					<Row>
						<Col lg={6} md={6} sm={12} xs={12} className={bt.space4}>
							<div className={cx(s.profileImgSection, s.profileImgWidth)}>
								<label className={bt.commonLabelText} >{formatMessage(messages.homeImage1)}</label>
								<CommonImageDisplay loader={homeImageLoader} imageSrc={homeSectionImage1 ? api?.apiEndpoint + homepageUploadDir + 'medium_' + homeSectionImage1 : null} />
								<ImageUploadComponent
									className='commonSiteAdminDropzoneSpace'
									subText={formatMessage(messages.maximumUploadSizeLabel)}
									defaultMessage={formatMessage(messages.chooseFile)}
									componentConfig={{
										iconFiletypes: ['.jpg', '.png', '.svg'],
										multiple: false,
										showFiletypeIcon: false,
										postUrl: api.apiEndpoint + '/uploadHomepageImage'
									}}
									success={this.successBanner}
									loaderName={'homeImageLoader'}
								/>
							</div>
						</Col>
						<Col lg={6} md={6} sm={12} xs={12} className={bt.space4}>
							<div className={cx(s.profileImgSection, s.profileImgWidth)}>
								<label className={bt.commonLabelText} >{formatMessage(messages.homeImage2)}</label>
								<CommonImageDisplay loader={homeImageLoader2} imageSrc={homeSectionImage2 ? api?.apiEndpoint + homepageUploadDir + 'medium_' + homeSectionImage2 : null} />
								<ImageUploadComponent
									className='commonSiteAdminDropzoneSpace'
									subText={formatMessage(messages.maximumUploadSizeLabel)}
									defaultMessage={formatMessage(messages.chooseFile)}
									componentConfig={{
										iconFiletypes: ['.jpg', '.png', '.svg'],
										multiple: false,
										showFiletypeIcon: false,
										postUrl: api.apiEndpoint + '/uploadHomepageImage'
									}}
									success={this.successImage}
									loaderName={'homeImageLoader2'}
								/>
							</div>
						</Col>
					</Row>

					<FieldArray
						name='homeSectionTitle1'
						rerenderOnEveryChange={true}
						component={this.renderBannerTitle}
						dynamicHomeBannerTitle={dynamicHomeBannerTitle} />

					<div className={cx(bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider, 'singleFlexEndBtn')}>
						<Form.Group className={s.formGroup}>
							<Loader
								type={"button"}
								label={formatMessage(messages.submitButton)}
								show={loading}
								buttonType={'submit'}
								className={cx(bt.btnPrimary, 'loaderButtonFlex')}
								disabled={submitting || loading}
							/>
						</Form.Group>
					</div>
				</Form>
			</div >
		)
	}
}

HomeSettingsForm = reduxForm({
	form: 'HomeSettingsForm',
	onSubmit: submit,
	validate
})(HomeSettingsForm);

const selector = formValueSelector('HomeSettingsForm')

const mapState = (state) => ({
	homeSectionImage1: selector(state, 'homeSectionImage1'),
	homeSectionImage2: selector(state, 'homeSectionImage2'),
	homeSectionImage3: selector(state, 'homeSectionImage3'),
	homeSectionImage4: selector(state, 'homeSectionImage4'),
	homeSectionImage5: selector(state, 'homeSectionImage5'),
	homeSectionImage6: selector(state, 'homeSectionImage6'),
	homeSectionImage7: selector(state, 'homeSectionImage7'),
	homeSectionImage8: selector(state, 'homeSectionImage8'),
	dynamicHomeBannerTitle: selector(state, 'homeSectionTitle1') || [],
	loading: state?.loader?.HomeSettingsForm,
	homeImageLoader: state?.loader?.homeImageLoader,
	homeImageLoader2: state?.loader?.homeImageLoader2,
	languageList: state?.runtime?.availableLocales,
})

const mapDispatch = {
	change,
	updateTempImages,
	demoRestriction
}

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(HomeSettingsForm)));